import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => {
  return {
    metaInfoWrapper: {
      border: 'solid 1px #EAEAEA',
      borderRadius: 6,
      display: 'block',
    },
    linkMetaData: {
      "& a": {
        color: 'inherit',
        textDecoration: 'none'
      },
      "& img": {
        height: 'auto',
        objectFit: "cover",
        width: "100%",
        display: "block",
        borderRadius: '6px 6px 0 0',
      },
    },
    metaInfo: {
      background: '#eef3f8',
      borderRadius: '0 0 6px 6px',
      padding: 12,
      textAlign: 'left'
    },
    linkImgDashboard: {
      height: '100% !important',
      width: "100% !important",
    },
    videoThumbnail: {
      position: "relative",
      "& img": {
        height: '100%',
        objectFit: "contain",
        padding: 15,
        width: "100%",
        display: "block"
      },
      "&:hover": {
        transition: ".3s",
        "& span": {
          background: "#ccc"
        }
      }
    },
    playIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      marginLeft: "-23px",
      marginTop: "-23px",
      borderRadius: "50%",
      background: "#fff",
      width: 46,
      height: 46,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg": {
        color: "#353f48",
        fontSize: 36
      }
    }
  };
});

export default useStyles;
